import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ServiceDrawerListItem from './ServiceDrawerListItem'
import ServiceDrawerCard from './ServiceDrawerCard'
import services from '../config/services'

const styles = theme => ({
  list: {
    flex: 'initial'
  },
  nested: {
    paddingLeft: 0
  }
})

const ServiceDrawerList = ({
  classes,
  handleClose,
  handleLocationClicked,
  handleLayerToggled,
  layersRendered,
  serviceCardChanged
}) => (
  <ServiceDrawerCard>
    <List className={classes.list}>
      {services.map((service, index) => (
        <ServiceDrawerListItem
          service={service}
          key={index}
          index={index}
          handleLocationClicked={handleLocationClicked}
          handleLayerToggled={handleLayerToggled}
          layersRendered={layersRendered}
          serviceCardChanged={serviceCardChanged}
        />
      ))}
    </List>
  </ServiceDrawerCard>
)

export default withStyles(styles)(ServiceDrawerList)



// WEBPACK FOOTER //
// ./src/components/ServiceDrawerList.js